//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../axios/axios.js'
import { mapGetters } from 'vuex'
import { createFieldConfig, Store } from '../../../components/QSelectUtils.js'
import ItemsSearchField from '../../../components/Field/ItemsSearchField.vue'

export default {
  components: {
    ItemsSearchField
  },
  props: {
    materialesAvailable: {
      type: Array,
      default () {
        return []
      }
    },
    reportId: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      consumptionToolKey: null,
      consumptionToolName: null,

      toolFieldConfig: createFieldConfig(new Store({
        itemsFn: this.getTools,
        searchable: true,
        searchFiltrationBySource: true,
        searchValueMinLength: 1
      })),
      stockFieldConfig: createFieldConfig(new Store({
        itemsFn: this.getStocks,
        cached: true,
        searchFiltrationBySource: false,
        searchColumns: ['stockName'],
        searchable: true,
        fullReadable: true
      })),

      request: {
        material: null,
        get materialKey () {
          return this.material ? this.material.id : null
        },
        stock: null,
        get stockKey () {
          return this.stock ? this.stock.stockKey : null
        },
        amount: null
      },

      loading: false,

      modalOpened: false
    }
  },
  computed: {
    ...mapGetters({
      stocks: 'getStocks'
    }),
    mobileDevice: function () {
      return document.body.classList.contains('mobile') || document.body.classList.contains('native-mobile')
    },
    disabledButtonSave: function () {
      return !this.request.materialKey || !this.request.stockKey
    }
  },
  methods: {
    onRequestMaterial: function (row) {
      this.prepareStocks()

      this.consumptionToolName = row.toolName
      this.consumptionToolKey = row.toolKey

      if (row.toolKey) {
        this.request.material = { id: row.toolKey, name: row.toolName }
      } else {
        this.request.material = null
      }

      this.request.amount = row.amount

      this.modalOpened = true
    },
    requestMaterial: function () {
      this.loading = true
      axiosGet({
        url: 'service/delta/report/' + this.reportId + '/consumptionToStock?stockKey=' + this.request.stockKey +
                                                                          '&toolKey=' + this.request.materialKey +
                                                                          '&amount=' + this.request.amount,
        onSuccess: (response) => {
          const material = response.data.result
          this.modalOpened = false

          if (!material) {
            this.$q.notify({
              type: 'negative',
              message: 'По данным 1С материал отсутствует на складе',
              progress: true,
              timeout: 8000
            })
          }

          if (!material.toolKey) {
            this.$q.notify({
              type: 'warning',
              message: 'Необходимое количество материала уже добавлено на склад',
              progress: true,
              timeout: 8000
            })
          }

          if (!material.amount || material.amount[0] <= 0) {
            this.$q.notify({
              type: 'negative',
              message: 'По данным 1С материал отсутствует на складе',
              progress: true,
              timeout: 8000
            })
          }

          const indexTool = this.materialesAvailable.map(item => item.toolKey).indexOf(material.toolKey)

          if (indexTool !== -1) {
            const indexStock = this.materialesAvailable[indexTool].stockKey.indexOf(material.stockKey[0])

            if (indexStock !== -1) {
              this.materialesAvailable[indexTool].amount[indexStock] = material.amount[0]
            } else {
              this.materialesAvailable[indexTool].stockKey.push(material.stockKey[0])
              this.materialesAvailable[indexTool].stockName.push(material.stockName[0])
              this.materialesAvailable[indexTool].amount.push(material.amount[0])
            }
          } else {
            this.materialesAvailable.push(material)
          }

          this.$emit('change-materiales-available', this.materialesAvailable)

          this.$q.notify({
            type: 'positive',
            message: 'Материал успешно добавлен на склад',
            progress: true,
            timeout: 3000
          })
          this.$q.notify({
            type: 'warning',
            message: 'При переносе расхода в списание актуализируйте связи с монтажом и демонтажом и удалите запись расхода',
            progress: true,
            timeout: 8000
          })
        },
        onFailure: 'Ошибка запроса материалов на склад',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    prepareStocks: function () {
      const brigadeStocks = this.getBrigadeStocks()
      if (brigadeStocks.length) {
        this.request.stock = brigadeStocks[0]
      }
    },
    getTools: function (text = '') {
      const urlName = '/service/delta/fastsearch/searchInTreeByPattern?tree=dictTools&limit=100&pattern=' + text
      return axiosGet({
        url: urlName,
        onSuccess: (response) => {
          return response.data
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message || 'Ошибка загрузки списка материалов',
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error('Ошибка загрузки списка материалов'))
        }
      })
    },
    getBrigadeStocks: function () {
      const brigadeStocks = []
      for (let i = 0; i < this.materialesAvailable.length; i++) {
        if (this.materialesAvailable[i].stockKey && this.materialesAvailable[i].stockKey.length) {
          for (let j = 0; j < this.materialesAvailable[i].stockKey.length; j++) {
            if (!brigadeStocks.map(stock => stock.stockKey).includes(this.materialesAvailable[i].stockKey[j])) {
              brigadeStocks.push({
                stockKey: this.materialesAvailable[i].stockKey[j],
                stockName: this.materialesAvailable[i].stockName[j],
                isBrigadeStock: true
              })
            }
          }
        }
      }
      return brigadeStocks
    },
    getStocks: function () {
      const brigadeStocks = this.getBrigadeStocks()
      const brigadeStocksKeys = brigadeStocks.map(stock => stock.stockKey)
      const otherStocks = this.stocks.filter(stock => !brigadeStocksKeys.includes(stock.stockKey))

      return [
        ...brigadeStocks,
        ...otherStocks
      ]
    },
    onSetTool: function (tool) {
      this.request.material = tool || null
    }
  }
}

